import { Popover, PopoverContent, PopoverTrigger } from 'ui/popover';
import { WebLink2 } from 'ui/theme';
import noop from 'utils/noop';
import { BaseSendEditorProps } from '../BaseSendEditor.types';
import SectionTitle from '../SectionTitle';
import { DeliveryText, PopoverLI, PopoverOL } from './DisplaySection.styled';
import DisplayUntil from './DisplayUntil';
import { EmbeddedDisplayPriority } from './EmbeddedDisplayPriority';

export interface DisplaySectionProps {
  banner?: BaseSendEditorProps['deliveryBanner'];
  campaignId?: number;
  isDisabled: boolean;
  title?: string;
  onDisplayPriorityOpen?: () => void;
}

export const DisplaySection = ({
  banner,
  campaignId,
  isDisabled,
  title,
  onDisplayPriorityOpen = noop,
}: DisplaySectionProps) => {
  return (
    <>
      <SectionTitle title={title} banner={banner} />
      <DeliveryText>
        Users will be eligible to see this message when they reach this tile in the journey.
        However, display priority and user behavior will determine if and when the user sees the
        message.&nbsp;&nbsp;
        <Popover>
          <PopoverContent TitleContent="Example cases of why a user who reaches this tile may not see this message">
            <PopoverOL>
              <PopoverLI>
                If other messages the user is eligible for have a higher display priority (including
                messages from other journeys the user is in)
              </PopoverLI>
              <PopoverLI>
                If the message is in a carousel or feed and the user does not scroll to it
              </PopoverLI>
              <PopoverLI>
                If the user does not open the app before the display until rules apply
              </PopoverLI>
            </PopoverOL>
          </PopoverContent>
          <PopoverTrigger>
            <WebLink2>See examples</WebLink2>
          </PopoverTrigger>
        </Popover>
      </DeliveryText>
      <EmbeddedDisplayPriority
        campaignId={campaignId}
        onOpen={onDisplayPriorityOpen}
        isDisabled={isDisabled}
      />
      <DisplayUntil campaignId={campaignId} isDisabled={isDisabled} />
    </>
  );
};
